import {Component, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Router, RouterModule, Routes} from '@angular/router';
import {SessionKeys} from 'src/app/app-config/SessionKeys';
import {AuthService} from 'src/app/auth/auth.service';
import {EncryptdecryptService} from 'src/app/auth/encryptdecrpt.service';
import {SidebarReponseModel} from 'src/app/models/sidebarResponse';
import {NavbarComponent} from '../navbar/navbar.component';
import {ToastrService} from 'ngx-toastr';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {
  public username: any;
  public menuList: any = [];
  public spliedClass: any = [];
  public parentList: Array<SidebarReponseModel> = [];
  public parentGlobal: Array<SidebarReponseModel> = [];
  searchInput = new FormControl();
  public assignparamedic: any;

  constructor(
    private toastr: ToastrService,
    private auth: AuthService,
    private router: Router,
    private encryptDecrypt: EncryptdecryptService,
  ) {}
  searchTxt() {
    if (this.searchInput.value) {
      this.parentList = this.parentGlobal;
      //this.parentList = arr.filter(i => i.sidemenu.TARGETNAME.toLowerCase().includes(this.searchInput.value.toString().toLowerCase()) || i.childList.find(j => j.TARGETNAME.toLowerCase().includes(this.searchInput.value.toString().toLowerCase())))
      this.parentList = this.parentList.map((permision: any) => {
        return {
          sidemenu: {
            TARGETNAME: permision.sidemenu.TARGETNAME,
            TARGETID: permision.sidemenu.TARGETID,
            isParent: permision.sidemenu.isParent,
            parentPosition: permision.sidemenu.parentPosition,
            parentId: permision.sidemenu.parentId,
            childPosition: permision.sidemenu.childPosition,
            URL: permision.sidemenu.URL,
            IMAGE: permision.sidemenu.IMAGE,
            WC_MT_ORDERLEVEL: permision.sidemenu.WC_MT_ORDERLEVEL,
            WC_MT_CLASS: permision.sidemenu.WC_MT_CLASS,
            WC_MT_ORDERDISPLAY: permision.sidemenu.WC_MT_ORDERDISPLAY,
            WC_TAR_EXECUTE: permision.sidemenu.WC_TAR_EXECUTE,
            WC_TAR_LANDING: permision.sidemenu.WC_TAR_LANDING,
            View: permision.sidemenu.View,
            WC_MT_SEQUENCE: permision.sidemenu.WC_MT_SEQUENCE,
            STEPS_ID: permision.sidemenu.STEPS_ID,
            SERVICE_ID: permision.sidemenu.SERVICE_ID,
          },
          childList: permision.childList.filter((j: any) =>
            j.TARGETNAME.toLowerCase().includes(
              this.searchInput.value.toLowerCase(),
            ),
          ),
        };
      });
      let arr = this.parentList;
      this.parentList = arr.filter(
        i =>
          i.sidemenu.TARGETNAME.toLowerCase().includes(
            this.searchInput.value.toString().toLowerCase(),
          ) ||
          i.childList.find(j =>
            j.TARGETNAME.toLowerCase().includes(
              this.searchInput.value.toString().toLowerCase(),
            ),
          ),
      );
      setTimeout(() => {
        //  $('.main-menu.has-collapsible').map((e,l)=>{$(l).addClass('active')})
        // console.log($('.main-menu.has-collapsible'));
        if (this.parentList.length > 0) {
          this.parentList.forEach((menu: any) => {
            this.setActive(menu.sidemenu.TARGETNAME);
          });
        }
      }, 10);
      // this.setActive(this.parentList[0].sidemenu.TARGETNAME)
    } else {
      this.parentList = this.parentGlobal;
    }
  }

  ngOnInit(): void {
    let userEncrypted = JSON.parse(
      sessionStorage.getItem(SessionKeys.userDetail) as string,
    );
    let userDecrypted = this.encryptDecrypt.passwordDecryption(userEncrypted);
    this.username = userDecrypted.data.Technician_Name;

    let data = JSON.parse(
      sessionStorage.getItem(SessionKeys.Menu_Details) as string,
    );
    this.menuList = data;
    //console.log("menu: ", sessionStorage.getItem(SessionKeys.Menu_Details) as string)
    this.menuList.forEach((value: any) => {
      if (value.isParent == true) {
        let obj = new SidebarReponseModel();
        obj.sidemenu = value;
        this.menuList.filter((datas: any) => {
          if (value.TARGETID == datas.parentId) {
            obj.childList.push(datas);
          }
        });
        obj.childList.sort(function (a, b) {
          return a.childPosition - b.childPosition;
        });
        this.parentList.push(obj);
      }
    });
    //console.log("parent:", this.parentList)
    this.parentList.sort(function (a, b) {
      return a.sidemenu.parentPosition - b.sidemenu.parentPosition;
    });
    const mastersMenu = this.parentList.find(
      (menu: any) => menu.sidemenu?.TARGETNAME === 'Masters',
    );
    if (mastersMenu) {
      const exists = mastersMenu.childList.find(
        (child: any) =>
          child.URL === '/weClean/masters/master-store-service-mapping',
      );
      if (!exists) {
        const storeMasterChild = mastersMenu.childList.find(
          (child: any) => child.URL === '/weClean/masters/store-master',
        );
        const menuTemplate = storeMasterChild || mastersMenu.childList[0];
        mastersMenu.childList.push({
          ...menuTemplate,
          TARGETNAME: 'Master Store Service Mapping',
          URL: '/weClean/masters/master-store-service-mapping',
          childPosition: storeMasterChild
            ? storeMasterChild.childPosition + 1
            : mastersMenu.childList.length + 1,
        });
        mastersMenu.childList.sort(
          (a: any, b: any) => (a.childPosition || 0) - (b.childPosition || 0),
        );
      }
    }
    this.parentGlobal = this.parentList;
    const openMenu = document.querySelector('.open-menu');
    const closeMenu = document.querySelector('.close-menu');
    const menuWrapper = document.querySelector('.life-sidebar');
    const menuaside = document.querySelector('.sidebar-sec');
    const mainContent = document.querySelector('.main-panel');
    const miniContent = document.querySelector('body');
    const hasCollapsible = document.querySelectorAll('.has-collapsible');

    // Sidenav Toggle
    // openMenu.addEventListener("click", function () {
    // 	menuWrapper.classList.add("mini-sidebar");
    // });

    // closeMenu.addEventListener("click", function () {
    // 	menuWrapper.classList.remove("mini-sidebar");
    // });
    // Collapsible Menu
    hasCollapsible.forEach(function (collapsible) {
      collapsible.addEventListener('click', function () {
        collapsible.classList.toggle('active');

        // Close Other Collapsible
        hasCollapsible.forEach(function (otherCollapsible) {
          if (otherCollapsible !== collapsible) {
            otherCollapsible.classList.remove('active');
          }
        });
      });
    });

    function resizeFunction(x: any) {
      if (x.matches) {
        // If media query matches
        menuWrapper?.classList.add('mini-sidebar');
        mainContent?.classList.add('full-content');
        menuaside?.classList.add('aside-sidebar');
        miniContent?.classList.add('mini-panel');
      } else {
        menuWrapper?.classList.remove('mini-sidebar');
        mainContent?.classList.remove('full-content');
        menuaside?.classList.remove('aside-sidebar');
        miniContent?.classList.remove('mini-panel');
      }
    }

    var x = window.matchMedia('(max-width: 961px)');
    resizeFunction(x); // Call listener function at run time
    x.addListener(resizeFunction); // Attach listener function on state changes

    // Sidenav Toggle
    openMenu?.addEventListener('click', function () {
      menuWrapper?.classList.add('mini-sidebar');
      mainContent?.classList.add('full-content');
      menuaside?.classList.add('aside-sidebar');
      miniContent?.classList.add('mini-panel');
    });

    closeMenu?.addEventListener('click', function () {
      // alert("hi");
      menuWrapper?.classList.remove('mini-sidebar');
      mainContent?.classList.remove('full-content');
      menuaside?.classList.remove('aside-sidebar');
      miniContent?.classList.remove('mini-panel');
    });
  }

  hasMenuChildren(parent: any): boolean {
    const list = parent?.childList;
    return Array.isArray(list) && list.length > 0;
  }

  menuChildren(parent: any): any[] {
    const list = parent?.childList;
    return Array.isArray(list) ? list : [];
  }

  setActive(TARGETNAME: any): void {
    // console.log(document.getElementById(TARGETNAME))
    this.spliedClass = document
      .getElementById(TARGETNAME)
      ?.className.split(' ');
    if (this.spliedClass[2] == 'active' || this.spliedClass[3] == 'active') {
      document.getElementById(TARGETNAME)!.classList.remove('active');
    } else {
      document.getElementById(TARGETNAME)!.classList.add('active');
    }
  }

  logout() {
    this.toastr.success('You have been logged out successfully!');
    this.auth.removeToken();
    this.router.navigateByUrl('');
  }
}
